import api from '../services/api';
import { setLocaleDefaults } from './helpers';

/** Public market defaults for date/money formatting. */
export async function hydrateLocalizationDefaults() {
    try {
        const { data } = await api.get('/common/localization');
        setLocaleDefaults({
            currency: data?.currency,
            locale: data?.locale,
            timezone: data?.timezone,
        });
        return data;
    } catch (err) {
        console.warn('Failed to hydrate localization defaults:', err?.message || err);
        return null;
    }
}
